export default __webpack_public_path__ + "static/media/3.cd0dadf7.jpg";